/**
 * Переход между разделами «Продажи» и «Склад» (вкладки на узком экране).
 * Пункты меню — в components/nav.ts. Переход — через View Transitions,
 * период и город из адреса сохраняются (как в финансовом блоке): открыв
 * «Менеджеров» из «Маржинальности за сентябрь», человек видит сентябрь.
 */

import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { withViewTransition } from '../finance/motion'

export function useInsightsNavigator() {
  const navigate = useNavigate()
  const location = useLocation()
  return useCallback(
    (path: string, extra?: Record<string, string>) => {
      const current = new URLSearchParams(location.search)
      const next = new URLSearchParams()
      for (const key of ['p', 'b']) {
        const value = current.get(key)
        if (value) next.set(key, value)
      }
      for (const [key, value] of Object.entries(extra ?? {})) next.set(key, value)
      const query = next.toString()
      const target = `${path}${query ? `?${query}` : ''}`
      if (`${location.pathname}${location.search}` === target) return
      withViewTransition(() => navigate(target))
      window.scrollTo({ top: 0 })
    },
    [navigate, location.pathname, location.search],
  )
}
